// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app." + "344d870eaf133e0b6dca" + ".js";
};